// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Og4M","image":"Header_image__2uaYx","name":"Header_name__3jhGI","info":"Header_info__7JrAc","infoRow":"Header_infoRow__1DErk"};